import { render, staticRenderFns } from "./CanvasCapacitacion.vue?vue&type=template&id=322e00ce&scoped=true"
import script from "./CanvasCapacitacion.vue?vue&type=script&lang=js"
export * from "./CanvasCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./CanvasCapacitacion.vue?vue&type=style&index=0&id=322e00ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e00ce",
  null
  
)

export default component.exports